import React, { useState } from "react";
import {Link} from "react-router-dom"
import styles from '../stylee/navbar.module.css';
import NavBarDrawerModel from "./NavBarDrawerModel";






function NavBar(){
    const [mobileMenu,setMobileMenu]= useState(false);


    return(
    <div  >
       

    <div className={styles.navBar} >
        <div className={styles.innerNavBar} >
       
        <div className={styles.navLeft}>
        <Link to="/" className={styles.linkTag} > <h2>Anyport</h2></Link> 
        </div>
        <div className={styles.navRight}>

        <Link to="/support" className={styles.linkTag}><h3 >Contact </h3></Link>
        <Link to="/order" className={styles.linkTag} > <h3>Order</h3></Link>
        <Link to="/login" className={styles.linkTag}><h3>Login</h3></Link>
        <Link to="/signup" className={styles.linkTag}><h3>Signup</h3></Link>
           
           
        </div>
        {/* Nav right ended */}
        </div>



        {/* ===================================================== */}

        <div className={styles.hamberger}>      
                
                {mobileMenu==false?
                // 
                 <img onClick={()=>setMobileMenu(!mobileMenu)}  src={require("../assets/hamburger.png")} alg="menu icon"/>
                
                :
                //
                <img  onClick={()=>setMobileMenu(!mobileMenu)}  src={require("../assets/cross.jpg")} alg="cross icon"/>
                }


        </div>


    {/* ========================================================= */}

    </div>

   <div className={styles.navdrawer}>
    <NavBarDrawerModel mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} />
    
    </div>

    </div>

    );

}



export default NavBar;